var exports = {
  "V": "x4ddf2309--38dbef--search-icon",
};

module.exports = exports;
